export default __webpack_public_path__ + "static/media/wall.c62883b6.png";